var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-list"},[(_vm.heading)?_c('h3',{staticClass:"grey",domProps:{"innerHTML":_vm._s(_vm.heading)}}):_vm._e(),_vm._l((_vm.sorted),function(item,key){return _c('TableItem',{key:key,attrs:{"item":item}},[_vm._v("\n    "+_vm._s(item.url)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }